import React, { Component } from 'react';
import $ from 'jquery';
import { Redirect } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUser, faKey, faEyeSlash, faEye } from '@fortawesome/free-solid-svg-icons';
import { login, setUser } from './../../actions/auth';
import { showBlocker, hideBlocker } from './../../actions/blocker';
import { connect } from 'react-redux';
import { navMap } from './../navbar/navbar';
import './styles.css';
import typeahead from '../typeahead/typeahead';

class Login extends Component {
    constructor(props) {
        super(props);
        this.state = {
            username: '',
            password: '',
            showPassword: false,
            data:''
        };
        this.onChange = this.onChange.bind(this);
        this.login = this.login.bind(this);
    }

    fromTypehead(disable) {
        this.setState({
            data: disable
        })
    }

    onChange(event) {
        event.preventDefault();
        let input = event.currentTarget;
        let change = {};
        change[input.name] = input.value;
        this.setState(change);
    }

    login(event) {
        this.props.showBlocker();
        event.preventDefault();
        let { username, password } = this.state;
        this.props.login(username, password).always(this.props.hideBlocker);
    }

    render() {
        let { auth, user, setUser, error } = this.props;
        let { username, password } = this.state;

        if (auth) {
            $.ajaxSetup({ headers: { 'Authorization': localStorage.getItem('effToken') } });
            if (!user) {
                this.props.showBlocker();
                setUser().always(this.props.hideBlocker);
            } else {
                let to = { pathname: navMap[user.perms.tabs[0]]['path'] };
                let from = this.props.location.state && this.props.location.state.from;
                if (from) {
                    if (user.perms.tabs.find(tab => navMap.hasOwnProperty(tab) && navMap[tab].path === from.pathname)) {
                        to = from;
                    }
                    if (from.pathname.match(/^\/flights\/[0-9]+$/) && user.perms.actions.includes('GENERATEEFF')) {
                        to = from;
                    }
                }
                return <Redirect to={to} />;
            }
            return null;
        }

        return (
            <div className='container'
                id='Login'>
                <div className='row justify-content-center'>
                    <div className='col-md-5 col-sm-8 my-5'>
                        <i className='icon' id='App-logo' />
                    </div>
                </div>
                <div className='row'>
                    <div className='col'>
                        <h4 className='text-center font-weight-normal'>Flight Dispatch Portal</h4>
                    </div>
                </div>
                <div className='row justify-content-center'>
                    <div className='col-md-5 col-sm-8 my-2'>
                        <div className='mb-2 text-center'>
                            <span className='text-danger'
                                style={{ whiteSpace: 'pre-wrap' }}>
                                {error}</span>
                        </div>
                        <form onSubmit={this.login}
                            autoComplete='off'>
                            <div className='form-group position-relative'>
                                <label className='position-absolute'
                                    htmlFor='username'>
                                    <i><FontAwesomeIcon icon={faUser} /></i>
                                </label>
                                <input type='text'
                                    className='form-control form-control-sm rounded-0 bg-transparent text-light pl-4'
                                    id='username'
                                    aria-describedby='usernameHelp'
                                    name='username'
                                    value={username}
                                    onChange={this.onChange}
                                    placeholder='Enter username' />
                            </div>
                            <div className='form-group position-relative'>
                                <label className='position-absolute'
                                    htmlFor='password'>
                                    <i><FontAwesomeIcon icon={faKey} /></i>
                                </label>
                                <input type={this.state.showPassword ? 'text' : 'password'}
                                    className='form-control form-control-sm rounded-0 bg-transparent text-light px-4'
                                    id='password'
                                    aria-describedby='passwordHelp'
                                    name='password'
                                    value={password}
                                    onChange={this.onChange}
                                    placeholder='Password' />
                                <i className='eye position-absolute'
                                    style={{ marginRight: this.state.showPassword ? '0' : '1px' }}
                                    onClick={_ => this.setState({ showPassword: !this.state.showPassword })}>
                                    {
                                        this.state.showPassword ?
                                            <FontAwesomeIcon icon={faEyeSlash} /> :
                                            <FontAwesomeIcon icon={faEye} />
                                    }
                                </i>
                            </div>
                            <div className='text-center'>
                                <button type='submit'
                                    className='btn btn-sm btn-block btn-light'>
                                    Login
                            </button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = state => ({ ...state.auth });

const mapActionsToProps = {
    login,
    setUser,
    showBlocker,
    hideBlocker,
};

export default connect(mapStateToProps, mapActionsToProps)(Login);
